module.exports = __webpack_public_path__ + "img/cross_5.ca3cac3e.png";